import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { UserStatus } from '@miro-site/utils-helpers';
import { Drawer } from '../drawer/drawer';
import { DrawerMenu } from './components/drawer-menu';
import { getMenuNode } from './helpers/get-menu-node';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Miro Header is our main header for the site.
 * It contains the main navigation and the meta menu and a drawer
 * menu for breakpoints below xl.
 *
 * @figma - https://www.figma.com/file/A90pL0uhBHbmuaP5By4DW3/Website-VIS2.0---Design-specifications?node-id=1%3A12476&mode=dev
 */
export var MiroDrawer = function MiroDrawer(_ref) {
  var _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      menu = _ref.menu,
      metaMenuLinks = _ref.metaMenuLinks,
      setIsOpen = _ref.setIsOpen,
      _ref$userStatus = _ref.userStatus,
      userStatus = _ref$userStatus === void 0 ? UserStatus.loggedIn : _ref$userStatus;

  /**
   * The currentMenuPath state is used to keep track of the menu that the
   * user has navigated to in the drawer menu. This is an array of indexes
   * that represent the path to the current menu in the menu's tree data structure.
   */
  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentMenuPath = _React$useState2[0],
      setCurrentMenuPath = _React$useState2[1];

  var menuNode = getMenuNode(menu, currentMenuPath);

  var handleBack = function handleBack() {
    /**
     * Removing the last index from the currentMenuPath array
     * to go back to the previous menu
     */
    setCurrentMenuPath(currentMenuPath.slice(0, -1));
  };

  var handleClose = function handleClose() {
    /**
     * Resetting all states when the drawer is closed
     */
    setCurrentMenuPath([]);
    setIsOpen(false);
  };

  return /*#__PURE__*/_jsx(Drawer, {
    backdropClassName: "d-xl-none",
    className: "d-xl-none",
    handleClose: handleClose,
    handleBack: handleBack,
    currentMenuPath: currentMenuPath,
    show: isOpen,
    title: (menuNode === null || menuNode === void 0 ? void 0 : menuNode.label) || 'Menu',
    children: /*#__PURE__*/_jsx(DrawerMenu, _objectSpread({
      userStatus: userStatus,
      menu: menuNode,
      currentMenuPath: currentMenuPath,
      setCurrentMenuPath: setCurrentMenuPath
    }, metaMenuLinks))
  });
};